module.exports = __webpack_public_path__ + "121a305e8375d496aaf027dfa93d81c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/logos/rakunew.png
// module id = 76
// module chunks = 0